import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import NuovaPratica from './pages/NuovaPratica'
import Pratiche from './pages/Pratiche'
import DettaglioPratica from './pages/DettaglioPratica'
import PraticaInviata from './pages/PraticaInviata'
import Documentale from './pages/Documentale'
import CalcolatoreFinanziamento from './pages/CalcolatoreFinanziamento'
import AdminUtenti from './pages/AdminUtenti'
import AdminCompagnie from './pages/AdminCompagnie'
import AdminTariffe from './pages/AdminTariffe'
import AdminParametri from './pages/AdminParametri'
import AdminStandalone from './pages/AdminStandalone'
import AdminEmail from './pages/AdminEmail'
import './styles/global.css'

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, profile, loading } = useAuth()
  if (loading) return <div className="loading">Caricamento...</div>
  if (!user) return <Navigate to="/login" replace />
  if (adminOnly && profile?.ruolo !== 'admin') return <Navigate to="/pratiche" replace />
  return <Layout>{children}</Layout>
}

function AppRoutes() {
  const { user, loading } = useAuth()
  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/pratiche" replace /> : <LoginPage />} />
      <Route path="/" element={<Navigate to="/pratiche" replace />} />

      <Route path="/pratiche" element={<ProtectedRoute><Pratiche /></ProtectedRoute>} />
      <Route path="/pratiche/nuova" element={<ProtectedRoute><NuovaPratica /></ProtectedRoute>} />
      <Route path="/pratiche/:id/modifica" element={<ProtectedRoute><NuovaPratica /></ProtectedRoute>} />
      <Route path="/pratiche/:id/inviata" element={<ProtectedRoute><PraticaInviata /></ProtectedRoute>} />
      <Route path="/pratiche/:id" element={<ProtectedRoute><DettaglioPratica /></ProtectedRoute>} />
      <Route path="/documentale" element={<ProtectedRoute><Documentale /></ProtectedRoute>} />
      <Route path="/calcolatore-finanziamento" element={<ProtectedRoute><CalcolatoreFinanziamento /></ProtectedRoute>} />

      <Route path="/admin/utenti" element={<ProtectedRoute adminOnly><AdminUtenti /></ProtectedRoute>} />
      <Route path="/admin/compagnie" element={<ProtectedRoute adminOnly><AdminCompagnie /></ProtectedRoute>} />
      <Route path="/admin/tariffe" element={<ProtectedRoute adminOnly><AdminTariffe /></ProtectedRoute>} />
      <Route path="/admin/parametri" element={<ProtectedRoute adminOnly><AdminParametri /></ProtectedRoute>} />
      <Route path="/admin/standalone" element={<ProtectedRoute adminOnly><AdminStandalone /></ProtectedRoute>} />
      <Route path="/admin/email" element={<ProtectedRoute adminOnly><AdminEmail /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/pratiche" replace />} />
    </Routes>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  )
}
